export default "__VITE_ASSET__d6703161__"